import React from "react";
import { useParams } from "react-router-dom";
import { useGhadiyaLogic } from "../../utils/Ghadiyo.logic";
import { ColorArray } from "../../config/ColorArray";
import "./Ghadia.css";


const Ghadiya = () => {
  const { num } = useParams();
  const { table, speak } = useGhadiyaLogic(Number(num));

  return (
    <div className="gh-main">
      <h1>{num} નો ઘડિયો</h1>

      {table.map((line, i) => {
        const color = ColorArray[i % ColorArray.length]?.color2;
        return (
          <div key={i} className="gh-row" style={{ color }} onClick={() => speak(line)}>
            {line}
          </div>
        );
      })}
    </div>
  );
};

export default Ghadiya;
